/**
 * Size Chart Modal
 * Handles opening, closing, and accessibility for the size chart modal
 */

class SizeChartModal {
  constructor() {
    this.modal = document.querySelector('[data-size-chart-modal]');
    if (!this.modal) return;

    this.triggers = document.querySelectorAll('[data-size-chart-trigger]');
    this.closeBtn = this.modal.querySelector('[data-size-chart-close]');
    this.overlay = this.modal.querySelector('[data-size-chart-overlay]');
    this.container = this.modal.querySelector('.size-chart-modal__container');

    this.isOpen = false;
    this.previouslyFocusedElement = null;

    this.init();
  }

  init() {
    if (!this.triggers || this.triggers.length === 0) return;

    // Event listeners for all trigger buttons
    this.triggers.forEach(trigger => {
      trigger.addEventListener('click', () => this.open());
    });

    this.closeBtn?.addEventListener('click', () => this.close());
    this.overlay?.addEventListener('click', () => this.close());

    // ESC key to close
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen) {
        this.close();
      }
    });

    // Trap focus inside modal
    this.modal.addEventListener('keydown', (e) => {
      if (e.key === 'Tab' && this.isOpen) {
        this.trapFocus(e);
      }
    });
  }

  open() {
    this.previouslyFocusedElement = document.activeElement;
    this.modal.classList.add('is-open');
    this.modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    this.isOpen = true;

    // Focus on close button
    setTimeout(() => {
      this.closeBtn?.focus();
    }, 100);
  }

  close() {
    this.modal.classList.remove('is-open');
    this.modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    this.isOpen = false;

    // Return focus to trigger button
    if (this.previouslyFocusedElement) {
      this.previouslyFocusedElement.focus();
    }
  }

  trapFocus(e) {
    const focusableElements = this.modal.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    const firstFocusable = focusableElements[0];
    const lastFocusable = focusableElements[focusableElements.length - 1];

    if (e.shiftKey) {
      // Shift + Tab
      if (document.activeElement === firstFocusable) {
        e.preventDefault();
        lastFocusable.focus();
      }
    } else {
      // Tab
      if (document.activeElement === lastFocusable) {
        e.preventDefault();
        firstFocusable.focus();
      }
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new SizeChartModal();
  });
} else {
  new SizeChartModal();
}
